<template>
  <div class="dataSendContainer">
    <router-view></router-view>

  </div>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
.dataSendContainer{
  height: 100%;
}
</style>
